import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Icon } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderColor: Color.darkRed,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
})

interface Props extends ViewProps {}

const Failed = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Icon name="close" color={Color.darkRed} size="S" />
    </View>
  )
}

export default Failed
